define([
    'layout',
    'backbone',
    'handlebars',
    'alert',
    'errors',
    'moment-wrapper',
    '@lib/autonumeric',
    'bignumber.js',
    'appcontext',
    'dirtytracker',
    'modules/common/views/utils',
    'modules/rore/orders/views/utils'
], (layout, Backbone, Handlebars, Alert, Errors, moment, autonumeric, BigNumber, appContext, dirtyTracker,
    utils, MEutils) => Backbone.View.extend({
    backRouteName: null,
    backRouteContext () {
        return {};
    },
    alert: Alert,

    clearErrorFields () {
        const prefix = '#errors-';
        const ids = prefix + this.fields.map((val) => val.replace(/_/g, '-')).
            join(`, ${prefix}`);

        $(ids).
            html('');
    },

    showErrorMessage (model, response) {
        Errors.showAPIErrorMessage(this.alert, response);
    },

    handleErrors (model, response, options) {
        const defaultOptions = {
            showMessage: true
        };
        const opts = _.extend(defaultOptions, options);

        if (!response.status || response.status < 500) {
            const self = this;
            const errors = Errors.getErrors(response);

            // we shouldn't show error messages for handleErrors of child views
            if (opts.showMessage) {
                Errors.showCorrectErrorMessage(this.alert, errors);
            }

            var renderErrors = function (prefix, errors) {
                $.each(errors, (i, val) => {

                    // composite value
                    if (_.isObject(val)) {

                        // nested field
                        if (!_.isArray(val)) {
                            renderErrors(`${prefix + i.replace(/_/g, '-')}-`, val);
                        } else {

                            // array (multiple errors)
                            self.$(`#${prefix}${i.replace(/_/g, '-')}`).
                                text(val.join('; '));
                        }
                    } else {

                        // simple error
                        self.$(`#${prefix}${i.replace(/_/g, '-')}`).
                            text(val);
                    }
                });
            };

            renderErrors('errors-', errors);
        }
    },

    parse_form (attributes) {
        const self = this;
        let value;

        function isBackbone (object) {
            return object instanceof Backbone.Collection || object instanceof Backbone.Model;
        }

        _.each(attributes, (v, attribute) => {
            let inputs = self.$('[name="{0}"]'.format(attribute));
            let nested = false;

            // may be attribute is nested?
            if (inputs.length === 0) {
                inputs = self.$('[name*="{0}["]'.format(attribute));
                nested = true;
            }
            inputs.each((index, el) => {
                const input = $(el);
                let object = attributes;
                let key = attribute;

                if (nested) {
                    const name = input.attr('name');
                    const params = name.slice(attribute.length + 1, name.length - 1).
                        split('][');
                    object = attributes[attribute];
                    key = params.pop();
                    _.each(params, (param) => {
                        object = isBackbone(object) ? object.get(param) : object[param];
                    });
                    object = isBackbone(object) ? object.attributes : object;
                }

                if (input.is(':checkbox')) {
                    object[key] = input.is(':checked');
                } else if (input.is(':radio')) {
                    const radioName = '[name="{0}"]:checked'.format(input.attr('name'));
                    const hasValue = self.$(`${radioName}[value]`).length;
                    const radio = self.$(radioName);
                    object[key] = hasValue ? radio.val() : !_.isUndefined(radio.data('checked-true'));
                } else if (input.hasClass('numeric')) {
                    value = input.autoNumeric('get');
                    if (input.hasClass('vat') && appContext.withVat()) {
                        value = new BigNumber(value).div(appContext.vatDivider()).
                            toFixed(2);
                    }
                    object[key] = value;
                } else if (input.hasClass('datepicker')) {
                    if (input.hasClass('timepicker')) {
                        value = input.datetimepicker('getDate');
                        object[key] = !_.isNull(value) ? moment(value).
                            formatDateTimeApi() : null;
                    } else {
                        value = input.datepicker('getDate');
                        object[key] = !_.isNull(value) ? moment(value).
                            formatDateApi() : null;
                    }
                } else if (input.hasClass('timepicker')) {
                    value = input.datetimepicker('getDate');
                    object[key] = !_.isNull(value) ? moment(value).
                        formatTimeApi() : null;
                } else {
                    object[key] = input.val();
                }
            });
        });

        return attributes;
    },

    uiLock (el) {
        if (_.isString(el)) {
            el = this.$(el);
        }

        el.find('select,button,input').
            each(function () {
                const control = $(this);
                control.data('prevDisabled', control.attr('disabled') || false);
                control.attr('disabled', true);
            });
    },

    uiUnlock (el) {
        if (_.isString(el)) {
            el = this.$(el);
        }

        el.find('select,button,input').
            each(function () {
                const control = $(this);
                control.attr('disabled', control.data('prevDisabled') || false);
            });
    },

    initNumeric (scope) {
        autonumeric.initNumeric(scope || this.$el);
    },

    changeWithVat () {
        const withVat = appContext.withVat();

        this.$('.numeric.vat').
            each(function () {
                const el = $(this);
                const settings = el.autoNumeric('getSettings');

                // Check that autoNumeric is initialized for this element
                if (settings) {
                    const vatDivider = new BigNumber(settings.vatDivider || 1);
                    let value = new BigNumber(el.autoNumeric('get') || 0);
                    value = withVat ? value.times(vatDivider) : value.div(vatDivider);
                    el.autoNumeric('set', value.toFixed(2));
                }
            });
    },

    navigateBack () {
        const router = appContext.router();
        dirtyTracker.reset();
        const successfulNavigate = router.navigatePrevious();
        if (!successfulNavigate) {
            const routeName = _.result(this, 'backRouteName');
            const routeContext = _.result(this, 'backRouteContext');
            const url = appContext.url(routeName, appContext.urlContext(routeContext));
            router.navigate(url, {replace: true});
        }
        return false; // return false for direct using on event handlers
    // e.g., "click .cancel": navigateBack
    },

    setStickyHeadersOffests () {

        /*
         * Unfortunately, we have to manipulate sticky headers here
         * as the attribute we are using (`offsetHeight`) is only set when a DOM is fully rendered
         *
         */
        let totalHeaderCellsHeight = 0;
        let smallestThInRow;

        $.each($('.wide-table-container > table > thead > tr:not(.summary)'), (rowIndex, row) => {
            if ($('th', $(row)).length > 0) {
                if (rowIndex > 0) {
                    $.each($('th', row), (thIndex, th) => {
                        $(th).
                            addClass('sticky-header-row');
                        $(th).
                            get(0).
                            style.
                            setProperty('--sticky-header-row-offset',
                                '{0}px'.format(totalHeaderCellsHeight.toString()));
                    });
                }

                smallestThInRow = $('th', row).
                    filter(function () {
                        return _.isUndefined($(this).
                            attr('rowspan'));
                    }).
                    get(0) || $('th:first', row).
                    get(0);

                totalHeaderCellsHeight += smallestThInRow.offsetHeight;
            }
        });
    },

    setStickyColumnsOffsets () {

        /*
         * Sad enough, but we have to repeat that jQuery-based post-render hack here to. See
         * `setStickyHeadersOffests` for details.
         *
         */
        const cellBordersColor = window.getComputedStyle(document.body).
            getPropertyValue('--table-border-color');
        const stickyPrefix = '.wide-table-container > table';
        let totalWidth;
        let previousStickyHeaderRowZIndex;
        let isNotFirstHeaderRow;
        const stickyObjects = {
            headerCell: {
                rowSelector: `${stickyPrefix} > thead > tr`,
                cellSelector: 'th.sticky-column-header'
            },
            tableCell: {
                rowSelector: `${stickyPrefix} > tbody > tr`,
                cellSelector: 'td.sticky-column-cell'
            }
        };

        previousStickyHeaderRowZIndex =
      window.getComputedStyle(document.body).
          getPropertyValue('--sticky-header-in-sticky-column-z-index');

        _.each(stickyObjects, (stickyObject, objectKey) => {
            $.each($(stickyObject.rowSelector), (rowIndex, row) => {
                totalWidth = 0;
                isNotFirstHeaderRow = rowIndex > 0 && objectKey === 'headerCell';

                if (isNotFirstHeaderRow) {
                    previousStickyHeaderRowZIndex -= 1;
                }

                $.each($(stickyObject.cellSelector, row), (cellIndex, cell) => {
                    if (isNotFirstHeaderRow) {
                        $(cell).
                            css('z-index', previousStickyHeaderRowZIndex.toString());
                    }

                    $(cell).
                        css('left', `${totalWidth.toString()}px`);

                    if (cellIndex === 0) {
                        $(cell).
                            css('border-left', `1px solid ${cellBordersColor}`);
                    } else {
                        $(cell).
                            css('border-left', '0');
                        $(cell).
                            prev().
                            css('border-right', `1px solid ${cellBordersColor}`);
                    }

                    totalWidth += $(cell).
                        get(0).offsetWidth;
                });
            });
        });
    },

    stickMassEditingBlocks () {
        if ($('.mass-edit-orders').length === 0) {
            return;
        }

        // we have to set block height explicitly because of using `position: fixed`
        MEutils.setDocumentStyleVar(
            '--mass-edit-sticky-block-height',
            `${$(MEutils.stickyBlockSelector).
                first().
                height()}px`
        );

        const headerTopOffset = $(MEutils.stickyBlockHeaderSelector).
            first().
            offset().top;
        const stickyBlockTopOffset = $(MEutils.stickyBlockSelector).
            first().
            offset().top;

        $(window).
            scroll(() => {

                /*
                 * inputs
                 * 46 = header height + content padding-top
                 */
                if ($(window).
                    scrollTop() >= stickyBlockTopOffset - 46) {
                    $(MEutils.stickyBlockSelector).
                        addClass(MEutils.fixedStickyBlockSelector.substring(1));
                    $(MEutils.stickyBlockPlaceholderSelector).
                        css('display', 'block');

                    $(MEutils.fixedStickyBlockSelector).
                        each(function () {
                            $(this).
                                width($(this).
                                    parent().
                                    width());
                        });
                } else {
                    $(MEutils.stickyBlockSelector).
                        removeClass(MEutils.fixedStickyBlockSelector.substring(1));
                    $(MEutils.stickyBlockPlaceholderSelector).
                        css('display', 'none');
                }

                // headers
                if ($(window).
                    scrollTop() >= headerTopOffset) {
                    $(MEutils.stickyBlockHeaderSelector).
                        addClass(MEutils.fixedStickyBlockHeaderSelector.substring(1));
                    $(MEutils.stickyBlockHeaderPlaceholderSelector).
                        css('display', 'block');

                    $(MEutils.fixedStickyBlockHeaderSelector).
                        each(function () {

                            // 38 = padding-left + padding-right (of content)
                            $(this).
                                width($(this).
                                    parent().
                                    width() - 38);
                        });
                } else {
                    $(MEutils.stickyBlockHeaderSelector).
                        removeClass(MEutils.fixedStickyBlockHeaderSelector.substring(1));
                    $(MEutils.stickyBlockHeaderPlaceholderSelector).
                        css('display', 'none');
                }
            });
    },

    /**
     * Common operation to perform after view appended to DOM.
     */
    afterShow () {

        /*
         * emulate autofocus for browsers that don't support autofocus
         * and for firefox too (it doesn't support autofocus on dynamically added elements)
         */
        this.$('[autofocus]').
            focus();
        this.renderHelp();

        /*
         * these function make specific columns stick if needed for views which has child table views inside them
         * they are here because this method is the only common place to execute functions which depends on
         * guaranty that view is already rendered to DOM completely
         *
         * it can't be placed to table.js beacuse afterShow is executed only for views that are appended in
         * layout.js directly, but table.js views are always child views
         */
        this.setStickyColumnsOffsets();
        this.setStickyHeadersOffests();
        this.stickMassEditingBlocks();

        const self = this;
        window.onresize = function () {
            self.setStickyColumnsOffsets();
        };
    },

    renderHelp () {
        utils.renderHelp.apply(this, arguments);
    },

    assign (view, selector) {
        view.setElement(this.$(selector)).
            render();
    }
}));
